/** The resource types a folder can organize. Single-type: a folder holds one.
 *  Values mirror the backend's `FolderResourceType_*` constants — hyphenated,
 *  matching the file-record class `"flow-session"`. */
export type FolderResourceType = "canvas" | "flow-session";

export const FOLDER_RESOURCE_TYPE_CANVAS: FolderResourceType = "canvas";
export const FOLDER_RESOURCE_TYPE_FLOW_SESSION: FolderResourceType =
  "flow-session";

export interface Folder {
  id: string;
  resource_type: FolderResourceType;
  /** Sharing scope for canvas folders; absent for resource types not workspace-scoped. */
  workspace_id?: string;
  /** Parent folder for nesting; absent = top level. */
  parent_folder_id?: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface CreateFolderRequest {
  resource_type: FolderResourceType;
  workspace_id: string;
  parent_folder_id?: string;
  name: string;
}

export interface UpdateFolderRequest {
  /** Rename when present. */
  name?: string;
  /** Move when present; null files the folder at the top level, a value re-parents it. */
  parent_folder_id?: string | null;
}

export interface FolderResponse {
  data: Folder;
}

export interface ListFoldersResponse {
  data: {
    folders: Folder[];
  };
}
